<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DPointPreview',
  extends: compoment
}
</script>
